import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { iconsSet as icons } from '@/assets/icons'
import CIcon from '@coreui/icons-vue'
import CoreuiVue from '@coreui/vue-pro'
import VueApexCharts from "vue3-apexcharts"
import timeago from 'vue-timeago3'

const app = createApp(App)
app.use(store)
app.use(router)
app.use(CoreuiVue)
app.provide('icons', icons)
app.component('CIcon', CIcon)
app.use(VueApexCharts)
app.use(timeago)

app.mount('#app')
